// In-memory department portal session store.
// Intentionally NOT persisted to localStorage — cleared on page refresh.
// Shore-side contacts use department workstations where persistence is fine,
// but we mirror the vessel portal pattern for consistency.

export interface DeptSession {
  token: string;
  id: string;
  name: string;
  role_name: string | null;
  email: string;
}

let session: DeptSession | null = null;

export function setDeptSession(s: DeptSession): void {
  session = s;
}

export function getDeptSession(): DeptSession | null {
  return session;
}

export function clearDeptSession(): void {
  session = null;
}

export function isDeptAuthenticated(): boolean {
  return session !== null;
}
